module.exports = __webpack_public_path__ + "static/media/presentation_2.b13ac306.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neonat/icons/presentation_2.svg
// module id = 630
// module chunks = 1